import { Button, Tooltip, Box, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import HistoryIcon from '@mui/icons-material/History';
import PageviewIcon from '@mui/icons-material/Pageview';
import DeleteSweepOutlinedIcon from '@mui/icons-material/DeleteSweepOutlined';
import BlockIcon from '@mui/icons-material/Block';
import SendIcon from '@mui/icons-material/Send';
import LoopIcon from '@mui/icons-material/Loop';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ConfirmDialogModal from './ConfirmDialogModal';
import Iconify from '../iconify';

ConfirmDialog.propTypes = {
  color: PropTypes.string,
  title: PropTypes.node,
  actionButton: PropTypes.string,
  tooltip: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  button: PropTypes.string,
  disabled: PropTypes.bool,
  disableRipple: PropTypes.bool,
  iconButtonSx: PropTypes.object,
  icon: PropTypes.string,
  action: PropTypes.func,
  cancelAction: PropTypes.func,
  iconSx: PropTypes.object,
  manualLoading: PropTypes.bool,
  content: PropTypes.node,
  buttonStyles: PropTypes.object,
  children: PropTypes.node,
  sx: PropTypes.object,
  startIcon: PropTypes.string
}
export default function ConfirmDialog({
  button,
  tooltip,
  disabled,
  disableRipple,
  iconButtonSx,
  action,
  cancelAction,
  iconSx,
  title = 'Delete',
  icon = 'delete-outline',
  color = 'error',
  actionButton = 'Delete',
  manualLoading = null,
  content,
  buttonStyles = {},
  children,
  sx,
  startIcon,
  ...other
}) {

  const [openConfirm, setOpenConfirm] = useState(false);

  const getIcon = useMemo(() => {
    const style = { verticalAlign: 'middle', ...iconSx };
    if (icon === 'delete-outline') {
      return <DeleteOutlineIcon sx={style} />;
    }
    if (icon === 'refresh') {
      return <LoopIcon sx={style} />;
    }
    if (icon === 'email-search') {
      return <PageviewIcon sx={style} />;
    }
    if (icon === 'browser-updated') {
      return <BrowserUpdatedIcon sx={style} />;
    }
    if (icon === 'delete-sweep') {
      return <DeleteSweepOutlinedIcon sx={style} />;
    }
    if (icon === 'block') {
      return <BlockIcon sx={style} />;
    }
    if (icon === 'history-outline') {
      return <HistoryIcon sx={style} />;
    }
    if (icon === 'save-and-send') {
      return <SendIcon sx={style} />;
    }
    if(icon === 'save'){
      return <CheckCircleIcon sx={style} />;
    }
    if (icon === 'add') {
      return <Iconify sx={style} icon="eva:plus-outline" />;
    }
    return null;
  }, [icon, iconSx]);


  const handleOpenConfirm = (e) => {
    e.preventDefault();
    e.confirmDialog = true;
    setOpenConfirm(true);
    e.stopPropagation();
  };

  return  <>
    {button ? (
      <Button
        variant={button}
        size="small"
        color={color}
        startIcon={startIcon !== undefined ? startIcon : getIcon}
        onClick={handleOpenConfirm}
        disabled={disabled}
        sx={{ ...buttonStyles, ...sx }}
      >
        {children ?? actionButton}
      </Button>
    ) : (
      <Tooltip arrow title={tooltip}>
        <Box component="span">
          <IconButton
            color={color}
            onClick={handleOpenConfirm}
            id="action-button"
            className="action-button"
            disabled={disabled}
            disableRipple={disableRipple}
            sx={disableRipple ? { p: 0, ...iconButtonSx } : iconButtonSx}
          >
            {getIcon}
          </IconButton>
        </Box>
      </Tooltip>
    )}
    <ConfirmDialogModal
      title={title}
      content={content}
      action={action}
      cancelAction={cancelAction}
      icon={icon}
      color={color}
      actionButton={actionButton}
      manualLoading={manualLoading}
      setOpenConfirm={setOpenConfirm}
      openConfirm={openConfirm}
      {...other}
    />
  </>
}